export default __webpack_public_path__ + "static/media/dinho.372d76a8.png";